import { Card, CardContent, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If, Else } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { GrantedLevelSection } from "./granted-level-section"
import { groupBySource, groupByLevel } from "./group-by-source"

export function GrantedSection() {
    const { breakdown } = useBoundContext()
    const sections = groupByLevel(groupBySource(breakdown.granted))

    return (
        <Card data-cy="access-granted-section">
            <CardContent>
                <Stack spacing={2}>
                    <Typography variant="subtitle1">Granted</Typography>
                    <If value={sections.length > 0}>
                        <Repeat
                            list={sections}
                            item={<GrantedLevelSection showHeading={sections.length > 1} />}
                            keyFn={keyOf}
                        />
                        <Else>
                            <Typography variant="body2" color="text.secondary">
                                Nothing is granted to this {breakdown.userId ? "user" : "client"} by products, bundles
                                or roles.
                            </Typography>
                        </Else>
                    </If>
                </Stack>
            </CardContent>
        </Card>
    )

    function keyOf(section) {
        return section.level
    }
}
